import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";

// This is implemented as a plugin because the BlockEditor scope doesn't have access to the editor:
export default function AutoFocusPlugin() {
  const [editor] = useLexicalComposerContext();
  useEffect(() => editor.focus(), [editor]);
  return null;
}
